module.exports = __webpack_public_path__ + "static/media/cert_98.dd914d0e.jpg";